import React from "react";

import {
  backgroundColorAlt,
  spacing8 as padding,
  backgroundColorLevelCurrent,
} from "@churchofjesuschrist/eden-style-constants";
import styled from "styled-components";

import LoadingSpinner from "../loading-spinner/loading-spinner";

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 200;
  pointer-events: ${(props) => (props.$modal ? "auto" : "none")};
`;
const Background = styled.div`
  &:before {
    content: " ";
  }
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.7);
  z-index: 200;
`;
const PopUp = styled.div`
  z-index: 200;
  padding: ${padding};
  background-color: ${backgroundColorLevelCurrent};
  border: 1px solid ${backgroundColorAlt};
  border-radius: 2px;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
`;

const LoadingModal = ({ active, modal = true, ...others }) => {
  return active ? (
    <div>
      <Container $modal={modal}>
        {modal ? <Background /> : undefined}

        <PopUp {...others}>
          <LoadingSpinner large={true} />
        </PopUp>
      </Container>
    </div>
  ) : undefined;
};

export default LoadingModal;
